<template>
  <div class="d-flex justify-content-center align-items-center py-2 text-white"
  style="background-color:  rgba(6, 147, 227, 0.3);">
  2022 F2E 4th week3
  </div>
</template>

<script>
export default {
};
</script>
